var map = {
	"./goldcoin/earn-icon-0.png": 33586,
	"./memetown/earn-icon-0.png": 65403,
	"./reflection/earn-icon-0.png": 81145,
	"./tapcoin/earn-icon-0.png": 43847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26515;